<template>
  <div class="record-list">
    <el-row :gutter="20" class="operate-bar">
      <el-col :span="4" align="left">
        <el-button icon="el-icon-back" @click="$router.back()">返回</el-button>
        <el-button icon="el-icon-download" @click="exportRecords">导出成绩</el-button>
      </el-col>
      <!-- 搜索区域 -->
      <el-col :span="20" align="right">
        <el-form :inline="true" :model="searchForm" class="search-form">
          <el-row>
            <el-form-item label="设备" v-show="showShooterFields">
              <el-select v-model="searchForm.targetImeis" filterable multiple placeholder="请选择设备" clearable>
                <el-option v-for="imei in targets" :key="imei" :label="imei" :value="imei"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="人员本地编号或姓名" v-show="showShooterFields">
                <el-input v-model="searchForm.shooterNo" placeholder="请输入人员本地编号或姓名" maxlength="6"
                @input="searchForm.shooterNo = searchForm.shooterNo.replace(/[^\d]/g, '').replace(/^0+/, '')"></el-input>
            </el-form-item>
            <el-form-item label="场次名称" v-show="showActivityFields">
              <el-select v-model="searchForm.activityId" filterable placeholder="请选择场次名称" clearable style="width: 100%">
                <el-option v-for="activity in activities" :key="activity.id" :label="activity.activityName" :value="activity.id"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="射击开始时间区间">
              <el-date-picker
                v-model="searchForm.datetimerange"
                type="datetimerange"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                >
              </el-date-picker>
            </el-form-item>
            <el-button icon="el-icon-search" type="primary" @click="loadRecords">查询</el-button>
            <el-button icon="el-icon-refresh" @click="resetSearch">重置</el-button>
          </el-row>
        </el-form>
      </el-col>
    </el-row>

    <!-- 数据表格 -->
    <el-table :data="records" border stripe style="width: 100%">
      <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
      <el-table-column prop="activityName" label="场次名称" header-align="center"></el-table-column>
      <el-table-column prop="shooterName" label="人员姓名" align="center"></el-table-column>
      <el-table-column prop="shooterNo" label="人员本地编号" align="center"></el-table-column>
      <el-table-column prop="startPhysicalTime" label="射击开始时间" 
        :formatter="(row, column, cellValue) => $options.filters.formatTime(cellValue)"
        align="center"></el-table-column>
      <el-table-column prop="totalScore" label="总成绩" align="center">
        <template slot-scope="scope">
          {{ scope.row.totalScore ? scope.row.totalScore + '环' : '' }}
        </template>
      </el-table-column>
      <el-table-column prop="shotSeq" label="击发数" align="center"></el-table-column>
      <el-table-column prop="hitShotSeq" label="命中数" align="center"></el-table-column>
      <el-table-column prop="shotTotalDuration" label="总用时" align="center">
        <template slot-scope="scope">
          {{ formatTimeToMMSSMS(scope.row.shotTotalDuration) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center" >
        <template slot-scope="scope">
          <el-tooltip content="成绩面板" placement="top">
            <el-button icon="el-icon-monitor" type="success" circle
              @click="$router.push({ name: 'RecordDetail', query: { roundNo: scope.row.roundNo, activityId: scope.row.activityId } })"></el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页 -->
    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
      :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
      :total="total"></el-pagination>
      
  </div>
</template>

<script>
import recordApi from '../../api/record';
import activityApi from '../../api/activity';
import store from '../../store';
import targetApi from '../../api/target';

export default {
  name: 'RecordList',
  data() {
    return {
      // 表格数据
      records: [], 
      activities: [],
      targets: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      // 搜索表单
      searchForm: {
        activityId: '',
        targetImeis: [],
        shooterNo: '',
        datetimerange: [],
      },
      showShooterFields: false, // 显示人员本地编号+姓名
      showActivityFields: false, // 显示场次名称

      userOrgs: store.state.user.userInfo.orgs,
    }
  },
  mounted() {
    this.searchForm.shooterNo = this.$route.query.shooterNo;
    this.searchForm.activityId = this.$route.query.activityId;
    // 根据参数设置显示状态
    if (this.searchForm.shooterNo) {
      // 传了shooterNo → 显示场次名称，隐藏人员字段
      this.showActivityFields = true;
      this.showShooterFields = false;
      this.loadActivities();
      this.targets = [];
    } else if (this.searchForm.activityId) {
      // 传了activityId → 显示人员字段，隐藏场次名称
      this.showShooterFields = true;
      this.showActivityFields = false;
      this.loadTargets();
    };
    this.loadRecords();
  },
  methods: {
    loadActivities() {
      // 组装请求参数
      const params = {
        userOrgIds: this.userOrgs.map(org => org.id), 
      };
      activityApi.findAll(params).then(response => {
        if (response.success) {
          this.activities = response.data.data
        } else {
          this.$message.error(response.message)
        }
      }).catch(error => {
        this.$message.error('加载场次失败：' + error.message)
      })
    },
    // 加载以分配的设备
    loadTargets() {
      recordApi.findByActivityIdWithData(this.searchForm.activityId).then(response => {
        if (response.success) {
          this.targets = response.data
        } else {
          this.$message.error(response.message)
        }
      }).catch(error => {
        this.$message.error('加载设备失败：' + error.message)
      })
    },
    // 加载射击记录列表
    loadRecords() {
      // 组装请求参数
      const params = {
        showActivityFields: this.showActivityFields, // 显示场次名称
        showShooterFields: this.showShooterFields,  // 显示人员本地编号+姓名
        activityId: this.searchForm.activityId, // 搜索-场次ID
        shooterNo: this.searchForm.shooterNo,   // 搜索-人员本地编号
        targetImeis: this.searchForm.targetImeis,  // 搜索-设备IMEI列表
        startTime: this.searchForm.datetimerange?.[0],  // 搜索-日期范围
        endTime: this.searchForm.datetimerange?.[1],    // 搜索-日期范围
        page: this.currentPage,               // 分页-当前页
        size: this.pageSize,                  // 分页-每页条数
        userOrgIds: this.userOrgs.map(org => org.id) // 用户所负责的组织机构ID列表
      };
      recordApi.findAll(params).then(response => {
        if (response.success) {
          this.records = response.data.data
          this.total = response.data.total
        } else {
          this.$message.error(response.message)
        }
      }).catch(error => {
        this.$message.error('加载射击记录列表失败：' + error.message)
      })
    },
    // 重置搜索
    resetSearch() {
      if (this.showShooterFields) {
        // 显示人员字段（对应传了activityId）→ 保留activityId，清空其他
        this.searchForm = {
          ...this.searchForm, // 保留原始对象引用
          targetImeis: [],    // 清空设备IMEI列表
          shooterNo: '',
          datetimerange: []   // 清空时间区间
          // activityId 会被保留
        };
      } else if (this.showActivityFields) {
        // 显示场次字段（对应传了shooterNo）→ 保留shooterNo，清空其他
        this.searchForm = {
          ...this.searchForm, // 保留原始对象引用
          activityId: '',    // 清空场次名称
          datetimerange: []   // 清空时间区间
          // shooterNo 会被保留
        };
      } else {
        // 无核心参数时（首次进入）→ 清空所有
        this.searchForm = {
          activityId: '',
          targetImeis: [],
          shooterNo: '',
          datetimerange: []
        };
      }
      this.loadRecords()
    },
    // 每页条数变化时
    handleSizeChange(val) {
      this.pageSize = val;
      this.loadRecords(); // 重新加载
    },
    // 当前页变化时
    handleCurrentChange(val) {
      this.currentPage = val;
      this.loadRecords(); // 重新加载
    },
    // 数字时间格式化为00:00.00
    formatTimeToMMSSMS(timeValue) {
      // 处理空值/非数字，默认0
      const timeNum = Number(timeValue) || 0;
      // 拆分：分钟 = 总秒数÷60；秒 = 总秒数%60；毫秒 = 小数部分×100（保留两位）
      const minutes = Math.floor(timeNum / 60);
      const seconds = Math.floor(timeNum % 60);
      const milliseconds = Math.round((timeNum - Math.floor(timeNum)) * 100);
      // 补零为两位字符串
      const fmtMin = String(minutes).padStart(2, '0');
      const fmtSec = String(seconds).padStart(2, '0');
      const fmtMs = String(milliseconds).padStart(2, '0');
      // 拼接成00:00.00格式
      return `${fmtMin}:${fmtSec}.${fmtMs}`;
    },
    // 导出成绩
    exportRecords() {
      // 准备导出参数（检索条件 + 用户组织ID）
      const params = {
        showActivityFields: this.showActivityFields, // 显示场次名称
        showShooterFields: this.showShooterFields,  // 显示人员本地编号+姓名
        activityId: this.searchForm.activityId, // 搜索-场次ID
        shooterNo: this.searchForm.shooterNo,   // 搜索-人员本地编号
        targetImeis: JSON.stringify(this.searchForm.targetImeis.map(target => target.imei)),   // 搜索-设备IMEI列表
        startTime: this.searchForm.datetimerange?.[0],  // 搜索-日期范围
        endTime: this.searchForm.datetimerange?.[1],    // 搜索-日期范围
        userOrgIds: JSON.stringify(this.userOrgs.map(org => org.id)) // 用户组织ID（必传，用于权限过滤）
      };

      // 调用API
      recordApi.exportRecords(params).then(response => {
        // 处理二进制流，创建下载链接
        const blob = new Blob([response.data], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `射击记录_${new Date().getTime()}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
      }).catch(err => {
        this.$message.error(`导出失败：${err.message || '网络错误'}`);
      });
    }
  }
}
</script>

<style scoped></style>